import { Component } from '@angular/core';
import { ButtonComponent } from '@flowkit/button';
import { DialogService } from '@flowkit/dialog';
import { MyDialogComponent } from '@features/dev/ui-components/dialog/my-dialog.component';

@Component({
  selector: 'app-ui-dialogs',
  imports: [ButtonComponent],
  template: `
    <div>
      <h1 class="heading-title">Dialog</h1>
      <div class="flex gap-10">
        <button flkButton (click)="openDialog()">Open Dialog</button>
      </div>
    </div>
  `,
})
export class UIDialogsComponent {
  constructor(private dialogService: DialogService) {}

  openDialog() {
    this.dialogService
      .open(MyDialogComponent, {
        title: 'My Dialog Component',
        data: {
          message: 'Hello, Marcelo 👋',
        },
      })
      .subscribe(result => console.warn(result));
  }
}
